import { useState } from 'react'
import { createPortal } from 'react-dom'
import Modal from '../../../ui/Modal'
import { deleteUserStyle } from '@ponpon/api-client'

interface DeleteStyleDialogProps {
  isOpen: boolean
  onClose: () => void
  styleId: string
  styleName: string
  onDeleted: () => void
}

export function DeleteStyleDialog({
  isOpen,
  onClose,
  styleId,
  styleName,
  onDeleted,
}: DeleteStyleDialogProps) {
  const [isDeleting, setIsDeleting] = useState(false)

  if (!isOpen) return null

  const handleDelete = async () => {
    setIsDeleting(true)
    try {
      await deleteUserStyle(styleId)
      onDeleted()
      onClose()
    } catch (err) {
      console.error('Failed to delete style:', err)
      setIsDeleting(false)
    }
  }

  return createPortal(
    <Modal isOpen={isOpen} onClose={onClose} title={`Delete "${styleName}"?`} size="sm">
      <p className="text-sm text-muted-foreground mb-4">
        This will permanently remove this style and its reference images. This action cannot be undone.
      </p>
      <div className="flex gap-2 justify-end">
        <button
          onClick={onClose}
          disabled={isDeleting}
          className="px-3 py-1.5 text-sm rounded-md border border-border hover:bg-surface-2 transition-colors"
        >
          Cancel
        </button>
        <button
          onClick={handleDelete}
          disabled={isDeleting}
          className="px-3 py-1.5 text-sm rounded-md bg-red-600 hover:bg-red-700 text-white transition-colors disabled:opacity-50"
          data-testid="delete-style-confirm-btn"
        >
          {isDeleting ? 'Deleting...' : 'Delete'}
        </button>
      </div>
    </Modal>,
    document.body,
  )
}
